module.exports = __webpack_public_path__ + "img/gsap-greensock.6ec18a3f.svg";